<template>
  <div class="activeok">
    <div class="div_mask">
      <div class="f-16 f-w" style="margin-top: 80px;align-items: center;display: inline-flex;">“凌志范儿”报名信息{{is_audit_name}}</div>
      <div class="f-14" style="margin-top: 14px;padding: 0 45px;" v-if="is_audit==0">审核结果请关注凌志范儿小程序消息通知</div>
      <div class="f-14" style="margin-top: 14px;padding: 0 45px;color: #666666;" v-if="is_audit==2">原因：{{refuse_reason}}</div>
      <div class="f-14" style="margin-top: 14px;padding: 0 45px;color: #666666;" @click="inviteAgain" v-if="is_audit==2">重新申请<img class="nextimg" :src="img.nextimg"></div>
      <div style="margin-top: 60px;text-align: center">
        <img class="qrcode" :src="img.lexus">
      </div>
      <div class="f-12"  v-clipboard="value" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">
        <div class="f-12" style="color: #999999;margin-bottom: 5px;">复制微信号 lingzhifaner</div>
        <div class="f-12" style="color: #999999;margin-bottom: 5px;">或长按保存二维码</div>
        <div class="f-12" style="color: #999999;margin-bottom: 5px;">添加“凌志范儿”微信为好友</div>
        <div class="f-12" style="color: #999999;margin-bottom: 5px;">获取活动最新信息</div>
      </div>
      <!-- <div class="f-12" style="color: #999999;margin-bottom: 5px;">长按添加凌志范儿官方微信</div>
      <div class="f-12" style="color: #999999;margin-bottom: 5px;">获取最新活动信息</div>
      <div class="f-12" style="color: #999999;margin-bottom: 5px;" v-clipboard="value" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">（微信号 lingzhifaner ）</div> -->
    </div>
  </div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon,Toast } from 'vant';
  export default {
    data () {
      return {
        value:'lingzhifaner',
        is_audit:0,
        is_audit_name:'审核中',
        img:{
          avatar:require('../../../assets/img/lexus/default.png'),
          sficon: require('../../../assets/img/lexus/approve/sficon.png'),
          lexus: require('../../../assets/img/lexus/approve/qrcode.png'),
          pagebg:require('../../../assets/img/lexus/approve/approveno_bg.png'),
          member_car: require('../../../assets/img/member_car.png'),
          border: require('../../../assets/img/lexus/border.gif'),
          nextimg: require('../../../assets/img/lexus/approve/nextimg.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {

      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.$store.dispatch('param/setToken', this.$route.query.token)
        this.getActivity(this.$route.query.userid)
      }else{
        this.source = this.$route.params.source
        this.token = this.$route.params.token
        this.$store.dispatch('param/setToken', this.$route.params.token)
        this.user_id = this.$route.params.user_id
        this.getActivity(this.$route.params.user_id)
      }
    },
    methods: {
      getActivity(id){
        var params={
          user_id:parseInt([id]),
        }
        common.getActivity(params,13).then(res => {
          if(res.data.state==1){
            this.activeinfo=res.data.data
            this.refuse_reason=res.data.data.refuse_reason
            if(res.data.data.is_audit==0){//审核中
              this.is_audit=0
              this.is_audit_name='审核中'
            }else if(res.data.data.is_audit==1){//审核通过
              this.is_audit=1
              this.is_audit_name='审核通过'
            }else if(res.data.data.is_audit==2){//审核不通过
              this.is_audit=2
              this.is_audit_name='审核未通过'
            }
          }
        })
      },
      inviteAgain(){
        if(this.source==9){
          this.$router.push({name:'LexusActived',params:{source:this.source,token:this.token,user_id:this.user_id,again:1}});
        }else{
          var params={
            url:this.weburl+'/lexus/active/actived?source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
      },
      clipboardSuccessHandler ({ value, event }){

       Toast('复制成功');
     },
     clipboardErrorHandler ({ value, event }) {
       console.log('error', value)
     }
   },
   components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Field.name]:Field,
    [Button.name]:Button,
    [Icon.name]:Icon,
    [Toast.name]:Toast
  }
}
</script>
<style lang="scss">
  .activeok{
    text-align: center;
    width: 100%;
    .div_mask{
      width: 100%;
      height: 100%;
      // background: rgba(0,0,0,.8);
    }
    .sficon{
      width: 18px;
      height: 18px;
      margin-right: 3px;
    }
    .qrcode{
      width: 160px;
      height: 160px;
    }
    .invitebtn{
      font-size: 14px;
      text-align: center;
      background: #605C6B;
      color: #fff;
      padding:15px 30px;
      position: fixed;
      top: 73%;
      left: 34%;
    }
    .info{
      min-height: 150px;
      z-index: 99;
      margin:30px 15px;
      background-color: #fff;
      border-radius: 1.5px;
      padding:20px;
      box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
      .headbox{
        position: relative;
        width: 60px;
        height: 60px;
      }
      .head{
        width: 60px;
        height: 60px;
        border-radius: 1.5px;
      }
      .headsficon{
        width: 60px;
        height: 60px;
        position: absolute;
        // bottom: 7px;
        right: 0px;
      }
      .buttonin{
        float: right;
        margin-top: 15px;
      }
      .van-button--small{
        height: 28px;
        padding: 0 8px;
        line-height: 20px;
        border-radius: 1px;
        vertical-align: middle;
      }
      .van-button__icon{
        font-size: 10px;
      }
      .van-button__text{
        font-size: 11px;
      }
      .member_car{
        width: 15px;
        height: 15px;
      }
    }
    .nextimg{
      width: 13px;
      height:12px;
      margin-left: 5px;
    }
    *{
      -webkit-user-select: none;/*禁用手机浏览器的用户选择功能 */
      -moz-user-select: none;
      -webkit-touch-callout: none;
      -ms-user-select:none; /*IE10*/
      user-select:none;
    }
  }
</style>
